// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dU9J","field":"styles_field__14Q5_","fieldCol":"styles_fieldCol__3uCLt","diffCol":"styles_diffCol__2VFIM","diff":"styles_diff__2ctd1"};